<template>
  <Modal
    :title="changePassword ? 'profile.forms.changedPassword.title' : 'profile.forms.password.title'"
    :hideButtons="['remove']"
    :saveBtnText="changePassword ? 'buttons.continue' : ''"
    @save="saveForm"
    v-model:open="openModal"
  >
    <div
      class="lp-profile-changed-password"
      v-if="changePassword"
    >
      <img
        class="lp-profile-changed-password__image"
        src="@/assets/images/changePassword.png"
      />
      <h3 class="lp-profile-changed-password__title">
        {{ $t('profile.forms.changedPassword.congratulation') }}
      </h3>
      <p class="lp-profile-changed-password__text">
        {{ $t('profile.forms.changedPassword.description') }}
      </p>
    </div>
    <Form
      class="lp-profile-form-password"
      @submit="saveForm"
      :inputs="profilePasswordInputs"
      v-else
    />
  </Modal>
</template>

<script>
import { ref, computed, watch } from 'vue';
import Modal from '@/components/Main/Modal/Modal';
import Form from '@/components/Main/Form/Form';
import profilePasswordInputs from '@/constants/inputs/profileTeacherInputs/profilePasswordInputs';
import { useStore } from 'vuex';
import validatePassword from '@/constants/validatesForm/validatePassword';
import AuthApi from '@/api/Auth/api';
import setErrorText from '@/constants/utils/setErrorText';

export default {
  name: 'ProfileFormPassword',
  components: {
    Modal,
    Form
  },
  props: {
    user: Object,
    open: Boolean
  },
  setup (props, { emit }) {
    const store = useStore();
    const activeUser = computed(() => store.getters.activeUser);

    const setLoaderRun = (data) => store.dispatch('setLoaderRun', data);

    const changePassword = ref(false);

    const openModal = ref(false);
    watch(openModal, () => {
      changePassword.value = false;
      emit('update:open', openModal.value);
    });

    const closeModal = () => {
      openModal.value = false;
      changePassword.value = false;
    };

    const setDefaultValues = () => {
      profilePasswordInputs.forEach((input) => {
        input.modelValue = '';
      });
    };

    watch(props, () => {
      if (props.open) setDefaultValues();
      openModal.value = props.open;
    });

    const saveForm = () => {
      if (changePassword.value) {
        closeModal();
        return;
      }
      const passwords = validatePassword(profilePasswordInputs);
      if (!passwords) return;
      passwords.email = activeUser.value.email;
      passwords.login = activeUser.value.login;
      const body = (({ newPasswordConfirm, ...rest }) => rest)(passwords);
      setLoaderRun(true);
      AuthApi.resetPassword(body).
        then(() => {
          setLoaderRun(false);
          changePassword.value = true;
        }).
        catch((err) => {
          console.error(err);
          setLoaderRun(false);
          setErrorText({ err, target: profilePasswordInputs, index: 2 });
        });
    };

    return {
      profilePasswordInputs, openModal, changePassword, saveForm, closeModal
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/style";

.lp-profile-changed-password,
.lp-profile-form-password {
  @include global-font;
  display: grid;
  width: 708px;
}

.lp-profile-changed-password {
  align-items: center;
  justify-content: center;
  background-color: $color-white;
  color: $color-text;

  &__image {
    width: 246px;
    height: auto;
    object-fit: contain;
    margin-top: 36px;
    margin-bottom: 24px;
  }

  &__title {
    font-weight: bold;
    font-size: 20px;
    line-height: 125%;
    text-align: center;
    margin-bottom: 4px;
  }

  &__text {
    font-weight: bold;
    font-size: 16px;
    line-height: 125%;
    text-align: center;
    margin-bottom: 16px;
  }
}

</style>
